import { render, staticRenderFns } from "./OzoneAlarmSet.vue?vue&type=template&id=68c7ae97&scoped=true"
import script from "./OzoneAlarmSet.vue?vue&type=script&lang=js"
export * from "./OzoneAlarmSet.vue?vue&type=script&lang=js"
import style0 from "./OzoneAlarmSet.vue?vue&type=style&index=0&id=68c7ae97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c7ae97",
  null
  
)

export default component.exports